import { TileLayer } from "react-leaflet";
import { useTheme } from "next-themes";

/**
 * Tile layer that follows the app's light/dark theme.
 *
 * Uses the OpenStreetMap standard tiles (no API key). CARTO basemaps started
 * returning "API key required" tiles, so they were dropped. Dark mode is a CSS
 * filter over the same tiles (`.leaflet-tile-dark` in index.css).
 */
export function ThemedTileLayer() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <TileLayer
      key={isDark ? "dark" : "light"}
      url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      maxZoom={19}
      keepBuffer={8}
      updateWhenZooming={false}
      updateWhenIdle={true}
      className={isDark ? "leaflet-tile-smooth leaflet-tile-dark" : "leaflet-tile-smooth"}
    />
  );
}
